import { Factory } from "../../core/factory";

export const registerChartPlugin = plugin => {
    Factory.registerChartPlugin(plugin.type, plugin);
};
//# sourceMappingURL=register.js.map
